export enum ScormStatusEnum {
  RUNNING = 'RUNNING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR'
}

export interface IScormCourse {
  id?: number
  topic_version_id?: number
  job_id?: string
  status?: string
  job_details?: {
    course: any
    status: string
  }
  file_details?: {
    filename: string
    filesize: string
  }
  preview?: string
  updated_at?: Date
}
